export default __webpack_public_path__ + "static/media/pkb-5.ebca28ce.png";